// src/pages/UserPhotos.jsx
import React from 'react';
const UserPhotos = () => {
  return <h1>Your Event Photos 🎉</h1>;
};
export default UserPhotos;
